// Maps a sku's backend tag name to a user-friendly "preference" label
export const preferencesByTagName = {
  'Gluten-Free': 'Gluten Free',
  'High-Protein': 'High Protein',
  '<600 Calories': 'Less than 600 Calories',
  'Low Sodium': 'Sodium Smart',
  'Less Prep': 'Less Prep',
};
